module.exports = __webpack_public_path__ + "img/card.eecf1efb.png";